import React, {
  useState,
  useEffect,
  useLayoutEffect,
  useCallback,
  useMemo,
} from "react";
import "./styles.scss";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import AddCircle from "@material-ui/icons/AddCircle";
import MaterialTable from "@material-table/core";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import AccordionActions from "@material-ui/core/AccordionActions";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import Checkbox from "@material-ui/core/Checkbox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import IconButton from "@material-ui/core/IconButton";
import Cookies from "universal-cookie";
import { useParams, useHistory, Link } from "react-router-dom";
import { MdUndo, MdSearch } from "react-icons/md";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import { DatePicker } from "@material-ui/pickers";
import { NotificationManager } from "react-notifications";
import { TabPanel } from "../../../Plugin/component";
import PropTypes from "prop-types";
import { ReportFilterLayout } from "../../../Plugin/component";
import { Nav, NavItem, NavLink } from "reactstrap";
import EditIcon from '@material-ui/icons/Edit';
import moment from "moment";
import { TwinSpin } from "react-cssfx-loading/lib";
import { Tooltip } from "@material-ui/core";

const cookies = new Cookies();
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

export default function PlanHandleComponent(props) {
  const [columns, setColumns] = React.useState([]);
  const [arrayheader, setArrayheader] = React.useState([]);

  const { id } = useParams();
  const [filterPlanTypeConfiguration, setFilterPlanTypeConfiguration] =
    useState([]);
  const history = useHistory();
  const [dataHeaderTableReport, setDataHeaderTableReport] = useState();
  const [headerColumns, setHeaderColumns] = useState([]);
  const [dataColumns, setDataColumns] = useState([]);
  const [childDateTime, setChildDateTime] = useState([]);
  const [activeTab, setActiveTab] = useState("1");
  // eslint-disable-next-line 
  const [Email, setEmail] = useState(cookies.get('usercode').email ? cookies.get('usercode').email : "");
  // eslint-disable-next-line 
  const [UserCode, setUserCode] = useState(cookies.get('usercode').userCode ? cookies.get('usercode').userCode : "");
  // eslint-disable-next-line 
  const [dataLayout, setDataLayout] = useState([]);
  const [isLoad, setLoad] = useState(false);
  const [dataPlans, setDataPlans] = useState([]);
  const [dataPlanHandle, setDataPlanHandle] = useState([]);

  function handleChangeTabPanel(tabValue) {
    if (activeTab !== tabValue) {
      setActiveTab(tabValue);
    }
  }

  // set active if filter is null 
  useEffect(() => { setActiveTab("1") }, [id, dataHeaderTableReport])

  const HandleCovertDateTime = useCallback((dateTime) => {
    const m = new Date(dateTime);
    const dateString =
      m.getUTCFullYear() +
      "/" +
      (m.getUTCMonth() + 1) +
      "/" +
      m.getUTCDate() +
      " " +
      m.getUTCHours() +
      ":" +
      m.getUTCMinutes() +
      ":" +
      m.getUTCSeconds();
    return dateString.split(" ")[0];
  }, []);

  const getPageSize = useMemo(() => {
    const pageSize = dataHeaderTableReport && dataHeaderTableReport[0]?.page;
    return pageSize ?? 5;
  }, [dataHeaderTableReport]);

  const getStickyColumn = useMemo(() => {
    const isStickyColumn =
      dataHeaderTableReport &&
      dataHeaderTableReport.filter((headerItem) => {
        return headerItem.pinColumn === true;
      });
    return isStickyColumn?.length ?? 0;
  }, [dataHeaderTableReport]);

  useEffect(() => {
    props.GetDataFilterReport(id);
    props.GetDataHeaderTableReport(id);
    // props.GetDataTableReport(id);
    return () => {
      props.ClearDataFilterReport();
    };// eslint-disable-next-line 
  }, [id]);

  const { DataFilterReport, DataHeaderTableReport, DataTableReport } = props;

  useEffect(() => {
    const dataFilterArray =
      DataFilterReport &&
      DataFilterReport.map((dataFilterReport, index) => {
        const { name, data, type, flex, rename } = dataFilterReport;
        if (type === "Datetime Between") {
          setChildDateTime((prev) => [
            ...prev,
            {
              name,
              data: HandleCovertDateTime(new Date()),
              dateType: "DatetimeFrom",
              index,
              content: "",
            },
            {
              name,
              data: HandleCovertDateTime(new Date()),
              dateType: "DatetimeTo",
              index,
              content: "",
            },
          ]);
        }
        return { name, data, type, flex, rename, child: [] };
      });
    setFilterPlanTypeConfiguration(dataFilterArray);

    return () => {
      setChildDateTime([])
    }
    // eslint-disable-next-line 
  }, [DataFilterReport, DataHeaderTableReport, id]);

  useEffect(() => {
    filterPlanTypeConfiguration &&
      filterPlanTypeConfiguration.map((data, index) => {
        if (data.type === "Datetime Between") {
          const childDateTimeCopy = childDateTime.filter((item) => {
            return item.index === index;
          });
          data.child = childDateTimeCopy;
        }
        return data;
      });

    return () => {

    }
    // eslint-disable-next-line 
  }, [childDateTime]);

  //clean up data chilDateTime

  useEffect(() => {
    return () => {
      setChildDateTime([])
    }
  }, [DataHeaderTableReport, id])

  useEffect(() => {
    DataHeaderTableReport && setDataHeaderTableReport(DataHeaderTableReport);
    const DataHeaderTableReportOnlyDateTime = DataHeaderTableReport && DataHeaderTableReport.filter((item) => { return item.type === "Datetime" })
    const dataTableReportConvert = DataTableReport && JSON.parse(props.DataTableReport);
    if (DataHeaderTableReportOnlyDateTime && DataHeaderTableReportOnlyDateTime.length > 0) {
      // eslint-disable-next-line
      DataHeaderTableReportOnlyDateTime.map((item) => {
        const CopyValue = dataTableReportConvert && dataTableReportConvert.map((data) => {
          const datetimevalue = data[item.rename]
          console.log("Dô đây");
          if (datetimevalue && datetimevalue.includes(" ")) {
            const datatimearray = datetimevalue.split(" ")

            data[item.rename] = new Intl.DateTimeFormat('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }).format(new Date(datatimearray[0])) + " " + datatimearray[1];
            return data
          }
          else {
            return data
          }
        })
        setDataColumns(CopyValue);
        setTimeout(() => {
          setDataPlans(CopyValue);
        }, 3000);
      })
    } else {
      props.DataTableReport && setDataColumns(JSON.parse(props.DataTableReport));
      props.DataTableReport && setTimeout(() => {
        setDataPlans(JSON.parse(props.DataTableReport));
      }, 3000);
    }
    // eslint-disable-next-line 
  }, [props]);

  useEffect(() => {
    let ArrayColumn = [];
    
    dataHeaderTableReport &&
    // eslint-disable-next-line
      dataHeaderTableReport.map((item, index) => {
        if (index === 0) {
          const abc = {
            title: item.rename ?? item.name,
            field: item.rename,
            filtering: false,
            editable: "never",
            render: (rowData) => {
              return (
                <Link to={"/PlanHandle/PlanHandleStep/" + rowData.PlanID}>
                  {rowData[item.rename]}
                </Link>
              );
            },
          };
          ArrayColumn.push(abc);
        } else {
          ArrayColumn.push({
            title: item.rename ?? item.name,
            field: item.rename,
            filtering: false,
            editable: "never",
            className: "abcdefgh",
            render: rowData => (
              <Tooltip title={rowData[item.rename]} style={{overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical'}}>
                <span>{rowData[item.rename]}</span>
              </Tooltip>
            ),
          });
        }
      });
    // ArrayColumn.push({
    //   title: "Copy",
    //   field: "PlanID",
    //   render: (rowData) => (
    //     <div>
    //       <IconButton
    //         className="editicon"
    //         onClick={() => Copybutton(rowData.PlanID)}
    //       >
    //         <FileCopyIcon />
    //       </IconButton>{" "}
    //     </div>
    //   ),
    //   filtering: false,
    //   editable: "never",
    // });
    ArrayColumn.push({
      title: 'Status',
      field: 'Status',
      filtering: false,
      //hidden: true,
      editable: "never"
    });
    ArrayColumn.push({
      title: "StepName",
      field: 'StepName',
      filtering: false,
      editable: "never"
    });
    setHeaderColumns(ArrayColumn);
  }, [dataHeaderTableReport]);

  useEffect(() => {
    let ArrayColumn = [];
    ArrayColumn.push({
      title: "Thao tác",
      field: "PlanID",
      render: (rowData) => (
        <div className="row">
          <IconButton
            title="Copy"
            className="col-6 editicon"
            onClick={() => Copybutton(rowData.PlanID)}
          >
            <FileCopyIcon />
          </IconButton>
          <IconButton
            title="Edit"
            className="col-6 editicon"
            hidden={rowData.HandleStep === 1 && (UserCode === rowData.CreateBy || (rowData.EditBy ? rowData.EditBy.includes(Email) : "") || (rowData.Admin ? rowData.Admin.includes(Email) : "")) ? false : true}
            onClick={() => Editbutton(rowData.PlanID)}
          >
            <EditIcon />
          </IconButton>{" "}
        </div>
      ),
      filtering: false,
      editable: "never",
    });
    // eslint-disable-next-line 
    arrayheader.map((item, index) => {
      if (index === 0) {
        ArrayColumn.push({
          title: item,
          field: item,
          filtering: false,
          editable: "never",
          render: (rowData) => (
            <Link to={"/PlanHandle/PlanHandleStep/" + rowData.PlanID}>
              {rowData[Object.keys(rowData)[0]]}
            </Link>
          ),
        });
      } else {
        if (item === 'PlanID') {
          ArrayColumn.push({
            title: "PlanID",
            field: "PlanID",
            hidden: true
          })
        }
        else if (item === 'CreateBy') {
          ArrayColumn.push({
            title: "CreateBy",
            field: "CreateBy",
            hidden: true
          })
        }
        else if (item === 'Admin') {
          ArrayColumn.push({
            title: "Admin",
            field: "Admin",
            hidden: true
          })
        }
        else if (item === 'EditBy') {
          ArrayColumn.push({
            title: "EditBy",
            field: "EditBy",
            hidden: true
          })
        }
        else if (item === 'Row') {
          ArrayColumn.push({
            title: "Row",
            field: "Row",
            hidden: true
          })
        }
        else if (item === 'CreateDate') {
          ArrayColumn.push({
            title: "CreateDate",
            field: "CreateDate",
            hidden: true
          })
        }
        else if (item === 'Status2') {
          ArrayColumn.push({
            title: "Status2",
            field: "Status2",
            hidden: true
          })
        }
        else {
          ArrayColumn.push({
            title: item === "Email" ? "Person in charge" : item,
            field: item,
            filtering: false,
            editable: "never",
            render: rowData => (
              <Tooltip title={rowData[item]} style={{overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical'}}>
                <span>{rowData[item]}</span>
              </Tooltip>
            ),
          });
        }
      }
    });
    setColumns(ArrayColumn);
    // eslint-disable-next-line 
  }, [arrayheader]);

  var curr = new Date();
  curr.setDate(curr.getDate());
  const tableRef = React.createRef();
  // eslint-disable-next-line 
  const [expanded, setExpanded] = React.useState("panel1");
  const [selectedFromDate, setFromDateChange] = useState(new Date(moment().subtract(7, 'd').format('YYYY-MM-DD')));
  const [selectedToDate, setToDateChange] = useState(new Date());
  // eslint-disable-next-line 
  const [LoaiKH, SetLoaiKH] = useState(0);
  // eslint-disable-next-line 
  const [Asigner, SetAsigner] = useState();
  const [Status, SetStatus] = useState();
  //   const { id } = useParams();
  // let history = useHistory();
  // eslint-disable-next-line 
  const [valueStatus, setValueStatus] = useState([
    { title: "Tất cả", value: -1 },
    { title: "Mới", value: 0 },
    { title: "Đóng", value: 1 },
    { title: "Hủy", value: 2 },
    { title: "Từ chối", value: 3 }
  ]);
  // eslint-disable-next-line 
  const [valueasigner, setvalueasigner] = useState([
    //{ title: isAuthenticated.fullName, value: 0 }
    { title: "Tất cả", value: 0 },
    { title: "TrongNM3@fpt.com", value: 1 },
    { title: "NgoanHT@fpt.com", value: 2 },
  ]);
  const date1 = Date.now();
  var todaynull = new Intl.DateTimeFormat("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  }).format(date1);

  // eslint-disable-next-line 
  if (selectedFromDate == "") {
    // eslint-disable-next-line 
    handleFromDateChange(todaynull);
    // eslint-disable-next-line 
    handleToDateChange(todaynull);
  }
  const handleFromDateChange = (event) => {
    setFromDateChange(event);
  };
  const handleToDateChange = (event) => {
    setToDateChange(event);
  };
  const Newbutton = () => {
    history.push("/PlanHandle/New/" + id);
  };
  const Copybutton = (PlanID) => {
    history.push("/PlanHandle/New/" + id + "/clone/" + PlanID);
  };
  const Editbutton = (PlanID) => {
    history.push("/PlanHandle/New/" + id + "/Edit/" + PlanID);
  };
  useEffect(() => {
    const DataSearch = {
      ID: id,
      StepNumber: 0,
      // createDate: selectedFromDate,
      // ToDate: selectedToDate,
      Email: cookies.get("usercode").email ? cookies.get("usercode").email : "",
    };
    props.GetDataPlanHandle(DataSearch);
    // eslint-disable-next-line 
  }, [id]);

  useEffect(() => {
    if (
      props.DataPlanHandle !== undefined &&
      Object.keys(props.DataPlanHandle).length > 0
    ) {
      setArrayheader(Object.keys(props.DataPlanHandle[0]));
    }
  }, [props.DataPlanHandle]);

  useEffect(() => {
    if (props.isResult) {
      const DataSearch = {
        ID: id,
        StepNumber: 0,
        // createDate: selectedFromDate,
        // ToDate: selectedToDate,
        Email: cookies.get("usercode").email
          ? cookies.get("usercode").email
          : "",
      };
      props.GetDataPlanHandle(DataSearch);
    }
    // eslint-disable-next-line
  }, [props.isResult]);

  useEffect(() => {
    props.DataPlanHandle && setTimeout(() => {
      setDataPlanHandle(props.DataPlanHandle);
      setLoad(false);
    }, 1000)
  }, [props.DataPlanHandle])

  useLayoutEffect(() => {
    setDataLayout(props.DataLayout)
  }, [props.DataLayout])

  const theme = createTheme({
    palette: {
      primary: {
        main: "#4facfe",
      },
      secondary: {
        main: "#4facfe",
      },
    },
  });

  const handleLoading = () => {
    setLoad(true);
    setDataPlanHandle();
  }

  const fn_SetStatus = (newValue, reason) => {
    if (reason === "select-option") {
      if (
        newValue.some((x) => x.value === -1) ||
        (!newValue.some((x) => x.value === -1) &&
          newValue.length === valueStatus.length - 1)
      ) {
        SetStatus(valueStatus);
      } else {
        SetStatus(newValue);
      }
    } else if (reason === "remove-option") {
      if (newValue.some((x) => x.value === -1)) {
        var index = newValue.findIndex((x) => x.value === -1);
        SetStatus([...newValue.slice(0, index), ...newValue.slice(index + 1)]);
      } else if (
        !newValue.some((x) => x.value === -1) &&
        newValue.length === valueStatus.length - 1
      ) {
        SetStatus();
      } else {
        SetStatus(newValue);
      }
    } else if (reason === "clear") {
      SetStatus();
    }
  };
  const fn_search = () => {
    handleLoading();
    if (selectedFromDate && selectedToDate) {
      let Statusarray1 = 0;
      if (Status) {
        const case1 = Status.filter((item) => item.value === 0);
        const case2 = Status.filter((item) => item.value === 1);
        const case3 = Status.filter((item) => item.value === 2);
        const case4 = Status.filter((item) => item.value === 3);
        if (Object.keys(Status).length === 2) {
          if (case1.length === 1 && case2.length === 1) {
            Statusarray1 = -2;
          }
          else if (case2.length === 1 && case3.length === 1) {
            Statusarray1 = -3;
          }
          else if (case1.length === 1 && case3.length === 1) {
            Statusarray1 = -4;
          }
          else if (case1.length === 1 && case4.length === 1) {
            Statusarray1 = -5;
          }
          else if (case2.length === 1 && case4.length === 1) {
            Statusarray1 = -6;
          }
          else if (case4.length === 1 && case3.length === 1) {
            Statusarray1 = -7;
          }
        }
        else if (Object.keys(Status).length === 3) {
          if (case1.length === 1 && case2.length === 1 && case3.length === 1) {
            Statusarray1 = -8;
          }
          else if (case4.length === 1 && case2.length === 1 && case3.length === 1) {
            Statusarray1 = -9;
          }
          else if (case4.length === 1 && case2.length === 1 && case1.length === 1) {
            Statusarray1 = -10;
          }
          else if (case4.length === 1 && case3.length === 1 && case1.length === 1) {
            Statusarray1 = -11;
          }
        }
        else if (Object.keys(Status).length === 4) {
          Statusarray1 = -1;
        }
        else {
          Statusarray1 = Status[0].value;
        }
      }
      else {
        Statusarray1 = -1;
      }
      const DataSearch1 = {
        ID: id,
        StepNumber: 0,
        Status: Statusarray1,
        createDate: selectedFromDate,
        ToDate: selectedToDate,
        Email: cookies.get("usercode").email
          ? cookies.get("usercode").email
          : "",
      };
      props.GetDataPlanHandle(DataSearch1);
    } else {
      NotificationManager.error("Vui lòng chọn thông tin ngày");
    }

    // let Statusarray = -2;
    // if (Status) {
    //   if (Object.keys(Status).length >= 2) {
    //     Statusarray = -1;
    //   } else {
    //     Statusarray = Status[0].value;
    //   }
    // }
    // const DataSearch = {
    //   ID: id,
    //   StepNumber: 0,
    //   Status: Statusarray,
    //   Email: cookies.get("usercode").email ? cookies.get("usercode").email : "",
    // };
    //props.GetDataPlanHandle(DataSearch)
  };

  // const fn_SetAsigner = (newValue, reason) => {
  //   if (reason === "select-option") {
  //     if (
  //       newValue.some((x) => x.value === 0) ||
  //       (!newValue.some((x) => x.value === 0) &&
  //         newValue.length === valueasigner.length - 1)
  //     ) {
  //       SetAsigner(valueasigner);
  //     } else {
  //       SetAsigner(newValue);
  //     }
  //   } else if (reason === "remove-option") {
  //     if (newValue.some((x) => x.value === 0)) {
  //       var index = newValue.findIndex((x) => x.value === 0);
  //       SetAsigner([...newValue.slice(0, index), ...newValue.slice(index + 1)]);
  //     } else if (
  //       !newValue.some((x) => x.value === 0) &&
  //       newValue.length === valueasigner.length - 1
  //     ) {
  //       SetAsigner();
  //     } else {
  //       SetAsigner(newValue);
  //     }
  //   } else if (reason === "clear") {
  //     SetAsigner();
  //   }
  // };
  const fn_reset = () => {
    SetLoaiKH();
    SetAsigner();
    SetStatus();
    setFromDateChange(new Date(moment().subtract(7, 'd').format('YYYY-MM-DD')));
    setToDateChange(new Date());
  };
  // const fn_SetLoaiKH = (newValue) => {
  //   SetLoaiKH(newValue);
  // };

  const HandleCheckAll = useCallback(
    ({ event, item }) => {
      if (filterPlanTypeConfiguration && item.type === "Multiple select") {
        const indexItem = filterPlanTypeConfiguration.findIndex(
          (itemFilter) => itemFilter.name === item.name
        );
        const selectAll =
          "Tất cả*" + filterPlanTypeConfiguration[indexItem].data;
        if (event === "Tất cả" && !item.content) {
          //check all if choose "Tất cả"
          return selectAll;
        } else if (event.split("*").length <= item.data.split("*").length && event.includes("Tất cả*")) {
          //uncheck all if unckeck one data
          return event.replace("Tất cả*", "");
        } else if (event.split("*").length === item.data.split("*").length && !event.includes("Tất cả*") && "Tất cả*" + event === item.content) {
          //uncheck all if uncheck "Tất cả"
          return "";
        } else if (event.split("*").length === item.data.split("*").length && item.content) {
          //chek all if choose all data
          return "Tất cả*" + event;
        } else if (event.includes("*Tất cả")) {
          //check all if choose "Tất cả"
          return selectAll;
        }
      }
      return event;
    },
    [filterPlanTypeConfiguration]
  );

  const HandleOnChange = (handleValue) => {
    const { item, event, index, dateType } = handleValue;

    if (dateType === "DatetimeFrom") {
      setChildDateTime(
        childDateTime.map((item) => {
          if (item.index === index && item.dateType === dateType) {
            item.data = HandleCovertDateTime(event) ?? "";
            item.content = event ?? "";
          }
          return item;
        })
      );
    } else if (dateType === "DatetimeTo") {
      setChildDateTime(
        childDateTime.map((item) => {
          if (item.index === index && item.dateType === dateType) {
            item.data = HandleCovertDateTime(event) ?? "";
            item.content = event ?? "";
          }
          return item;
        })
      );
    } else {
      // HandleCheckAll({event, item})
      //content is data
      setFilterPlanTypeConfiguration([
        ...filterPlanTypeConfiguration.slice(0, index),
        {
          ...filterPlanTypeConfiguration[index],
          content: HandleCheckAll({ event, item }),
        },
        ...filterPlanTypeConfiguration.slice(index + 1),
      ]);
    }
  };

  const removeSelectAllBeforeSubmit = useCallback(
    (state) => {
      return state.map((item) =>
        item?.content?.includes("Tất cả*")
          ? { ...item, content: item.content.replace("Tất cả*", "") }
          : item
      );
    },
    // eslint-disable-next-line 
    [filterPlanTypeConfiguration]
  );

  const handleSearchBasedOnFilter = () => {
    // let filterConfigNullContent = filterPlanTypeConfiguration.filter((item) => {
    //   return (
    //     !item.content &&
    //     item.type !== "Datetime Between" &&
    //     item.type !== "Datetime"
    //   );
    // });
    //validate time between date from and date to
    setDataPlans();
    setLoad(true);
    const filterConfigDateTime = filterPlanTypeConfiguration.filter(
      (item) => item.type === "Datetime Between"
    );
    const DataDateTimeChild = filterConfigDateTime.map((item, index) => {
      const dataTimeFrom = item.child[0].data;
      const dataTimeTo = item.child[1].data;
      return { index, dataTimeFrom, dataTimeTo };
    });
    if (DataDateTimeChild) {
      // eslint-disable-next-line
      DataDateTimeChild.map((item) => {
        if (
          new Date(item.dataTimeFrom) >
          new Date(item.dataTimeTo)
        ) {
          NotificationManager.error(
            `Ngày tháng ở trường "Từ ngày" phải nhỏ hơn ngày tháng ở trường "Đến ngày"`
          );
        }
      });
    }
    if (filterConfigDateTime) {
      const filterNullContent = filterPlanTypeConfiguration.filter((item) => item.type !== "Datetime Between" && !item.content);
      if (filterNullContent.length === filterPlanTypeConfiguration.length) {
        NotificationManager.warning("Vui lòng nhập ít nhất một trường dữ liệu!");
        return;
      }
    }
    // let DataPlanConfigComboboxFail = DataPlanConfig.filter((item)=> {return (item.colunmType === "Combobox" && item.colunmType === "Multiple select" && item.colunmType === "Datetime Between" ) && item.colunmData.length < 1})
    // if (filterConfigNullContent.length > 0) {
    //   NotificationManager.error("Vui lòng nhập thông tin.");
    // } else {
    if (id) {
      history.push({
        pathname: `/PlanHandle/Main/${id}`,
        state: { id, filterPlanTypeConfiguration },
      });
    }
    //}
    if (!history.location.state) {
      return false;
    } else {
      const stateFilterConfig = removeSelectAllBeforeSubmit(
        history.location.state?.filterPlanTypeConfiguration
      );
      props.GetDataTableReport(
        history.location.state.id,
        stateFilterConfig.map((item) => {
          return {
            Name: item.name,
            Data: item.content || "",
            Type: item.type,
            Child: item.child.map((itemChild) => {
              return {
                Name: itemChild.name,
                Data: itemChild.data,
              };
            }),
          };
        })
      );
    }
  };

  useEffect(() => {
    const DataHeaderTableReportOnlyDateTime = DataHeaderTableReport && DataHeaderTableReport.filter((item) => { return item.type === "Datetime" })
    const dataTableReportConvert = DataTableReport && JSON.parse(props.DataTableReport);
    if (DataHeaderTableReportOnlyDateTime && DataHeaderTableReportOnlyDateTime.length > 0) {
      // eslint-disable-next-line
      DataHeaderTableReportOnlyDateTime.map((item) => {
        const CopyValue = dataTableReportConvert && dataTableReportConvert.map((data) => {
          const datetimevalue = data[item.rename]
          const datatimearray = datetimevalue && datetimevalue.split(" ")
          data[item.rename] = new Intl.DateTimeFormat('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }).format(new Date(datatimearray[0])) + " " + datatimearray[1];
          return data
        })
        setDataColumns(CopyValue);
        setTimeout(() => {
          setDataPlans(CopyValue);
        }, 3000);
      })
    } else {
      props.DataTableReport && setDataColumns(JSON.parse(props.DataTableReport));
      props.DataTableReport && setTimeout(() => {
        setDataPlans(JSON.parse(props.DataTableReport));
      }, 3000);
    }
    // eslint-disable-next-line 
  }, [props.DataTableReport]);

  const GetValuePlanHandle = useMemo(() => {
    const valuePlanHandleName = props.DataLayout && props.DataLayout.filter((item) => { return item.url === `/PlanHandle/Main/${id}` })[0]?.name
    return valuePlanHandleName ?? ""
    // eslint-disable-next-line 
  }, [id])

  if (isLoad && (!dataPlans || !dataPlanHandle)) {
    return <div style={{ position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }} >
      <TwinSpin color="var(--itsm-bg-btn)" width="50px" height="50px" duration="0.5s" />
    </div>
  }

  if (!props.DataPlanHandle) {
    return (
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <CircularProgress className="CircularProgress" disableShrink />
      </div>
    );
  } else {
    return (
      <div className="material-tab-container">
        {filterPlanTypeConfiguration &&
          filterPlanTypeConfiguration.length !== 0 && (
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={`nav-link-tab${activeTab === "1"
                    ? " active active-customize-tab"
                    : " unactive-tab"
                    }`}
                  onClick={() => handleChangeTabPanel("1")}
                >
                  Kế Hoạch
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={`nav-link-tab${activeTab === "2"
                    ? " active active-customize-tab"
                    : " unactive-tab"
                    }`}
                  onClick={() => handleChangeTabPanel("2")}
                >
                  Báo cáo
                </NavLink>
              </NavItem>
            </Nav>
          )}
        <div>
          {activeTab === "1" && (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
              }}>
              <div className="Bodyui" style={{ maxWidth: "94%", width: "100%" }}>
                <div className="header-bodyui">
                  <b className="ml-3" style={{ fontSize: 20 }}>
                    {GetValuePlanHandle}
                  </b>
                  <div className="row buttonadd">
                    <div className="col-md-2">
                      <Button
                        variant="contained"
                        color="secondary"
                        className={"add-new-button btn"}
                        startIcon={<AddCircle />}
                        onClick={Newbutton}
                        style={{ border: '2px solid', height: '50px', width: '160px' }}
                      >
                        Tạo mới
                      </Button>
                    </div>
                  </div>
                </div>
                <Accordion
                  className="PlanHandle_002"
                  expanded={expanded === "panel1"}
                >
                  <AccordionSummary
                    aria-controls="panel1bh-content"
                    id="panel1bh-header"
                  >
                    <Typography className={"abc"}>Bộ lọc</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    {/* <div className="col-md-6 PlanHandle_0014">
                      <Autocomplete
                        id="combo-box"
                        options={[]}
                        size="small"
                        getOptionLabel={(option) => option.PlanID}
                        style={{ width: "100%" }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            margin="dense"
                            label="Tên Loại"
                            variant="outlined"
                          />
                        )}
                        renderOption={(option) => (
                          <Typography noWrap style={{ fontSize: "13px" }}>
                            {option.PlanID}
                          </Typography>
                        )}
                        className="PlanHandle_0013"
                        onChange={(e, newValue) => fn_SetLoaiKH(newValue)}
                        value={LoaiKH ? LoaiKH : null}
                      />
                    </div>
                    <div className="col-md-6 PlanHandle_0014">
                      <Autocomplete
                        multiple
                        id="combo-box"
                        limitTags={5}
                        options={valueasigner}
                        renderOption={(option, { selected }) => (
                          <React.Fragment>
                            <ThemeProvider theme={theme}>
                              <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              <Typography noWrap style={{ fontSize: "13px" }}>
                                {option.title}
                              </Typography>
                            </ThemeProvider>
                          </React.Fragment>
                        )}
                        size="small"
                        getOptionLabel={(option) => option.title}
                        style={{ width: "100%" }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            margin="dense"
                            label="Người xử lý"
                            variant="outlined"
                          />
                        )}
                        className="PlanHandle_0013"
                        value={Asigner ? Asigner : []}
                        onChange={(e, newValue, reason) =>
                          fn_SetAsigner(newValue, reason)
                        }
                      />
                    </div> */}
                    <div className="col-md-6 PlanHandle_0014">
                      <Autocomplete
                        multiple
                        id="combo-box"
                        limitTags={5}
                        options={valueStatus}
                        disableCloseOnSelect
                        renderOption={(option, { selected }) => (
                          <React.Fragment>
                            <ThemeProvider theme={theme}>
                              <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              <Typography noWrap style={{ fontSize: "13px" }}>
                                {option.title}
                              </Typography>
                            </ThemeProvider>
                          </React.Fragment>
                        )}
                        size="small"
                        getOptionLabel={(option) => option.title}
                        style={{ width: "100%" }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            margin="dense"
                            label="Trạng thái"
                            variant="outlined"
                          />
                        )}
                        className="PlanHandle_0013"
                        value={Status ? Status : []}
                        onChange={(event, newValue, reason) =>
                          fn_SetStatus(newValue, reason)
                        }
                      />
                    </div>
                    <div className="col-md-6 PlanHandle_0014 PlanHandle_0015">
                      <DatePicker
                        className="PlanHandle_0013"
                        fullWidth
                        animateYearScrolling
                        format="dd/MM/yyyy"
                        label="Từ ngày"
                        inputVariant="outlined"
                        margin="dense"
                        value={selectedFromDate}
                        onChange={handleFromDateChange}
                      />
                      <div className="clsNg">
                        <span> ~ </span>
                      </div>
                      <DatePicker
                        className="PlanHandle_0013"
                        fullWidth
                        animateYearScrolling
                        format="dd/MM/yyyy"
                        label="Đến ngày"
                        inputVariant="outlined"
                        margin="dense"
                        value={selectedToDate}
                        onChange={handleToDateChange}
                      />
                    </div>
                  </AccordionDetails>
                  <AccordionActions>
                    <Button
                      onClick={fn_search}
                      className="PlanHandle_0021"
                      size="small"
                      startIcon={<MdSearch />}
                      variant="contained"
                      color="primary"
                    >
                      Tìm Kiếm
                    </Button>
                    <Button
                      onClick={fn_reset}
                      className="PlanHandle_0022"
                      size="small"
                      startIcon={<MdUndo />}
                      variant="contained"
                      color="primary"
                    >
                      Làm mới
                    </Button>
                  </AccordionActions>
                </Accordion>
              </div>
              <div className="tablelistsms" style={{ maxWidth: "94%", width: "100%" }}>
                <MaterialTable
                  tableRef={tableRef}
                  columns={columns}
                  data={props.DataPlanHandle}
                  style={{
                    borderRadius: '20px',
                    boxShadow: 'rgb(100 100 111 / 20%) 0px 7px 29px 0px',
                    border: 'none',
                  }}
                  options={{
                    tableLayout: "auto",
                    toolbar: true,
                    paging: true,
                    pageSize: 10,
                    exportButton: {
                      csv: true,
                      pdf: false,
                    },
                    exportAllData: true,
                    filtering: true,
                    selection: false,
                    headerStyle: {
                      backgroundColor: "var(--itsm-bg-btn)",
                      color: "#FFF",
                      marginTop: "1%",
                      height: 100, maxHeight: 100, lineHeight: 1, textAlign: 'center', overflow: 'none',
                      paddingRight: 0, paddingBottom: 0, paddingTop: 0
                    },
                    rowStyle: rowData => ({
                      backgroundColor: ((rowData.Email && rowData.Email.includes(Email)) || (rowData.Assignee ? rowData.Assignee.includes(Email) : rowData.Assignee === Email)) && rowData.Status === 'Mới'
                        ? "#e9f3ff"
                        : "#fff",
                      fontWeight: ((rowData.Email && rowData.Email.includes(Email)) || (rowData.Assignee ? rowData.Assignee.includes(Email) : rowData.Assignee === Email)) && rowData.Status === 'Mới'
                        ? "bold"
                        : "normal"
                    })
                    ,
                    actionsColumnIndex: -1,
                  }}
                  localization={{
                    pagination: {
                      labelDisplayedRows: "Từ {from} - đến {to} of {count}",
                    },
                    toolbar: {
                      exportCSVName: "Export danh sách chi tiết",
                      nRowsSelected: "Đã chọn {0} dòng",
                    },
                    header: {
                      actions: "",
                    },
                    body: {
                      emptyDataSourceMessage: "Không có dữ liệu",
                      deleteTooltip: "Xóa",
                      filterRow: {
                        filterTooltip: "Filter",
                      },
                      editRow: {
                        deleteText: "Bạn đã thực sự chắc chắn muốn xóa?",
                        cancelTooltip: "Hủy bỏ",
                        saveTooltip: "Đồng ý",
                      },
                    },
                  }}
                  title=""
                />
              </div>
            </div>
          )}
        </div>
        <div>
          {activeTab === "2" && (
            <div className="" style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}>
              <div className="Bodyui" style={{ maxWidth: "94%", width: "100%" }}>
                <div className="PlanTemplate_body">
                  <Accordion
                    className="PlanHandle_002"
                    expanded={expanded === "panel1"}
                  >
                    <AccordionSummary
                      aria-controls="panel1bh-content"
                      id="panel1bh-header"
                    >
                      <Typography className={"filter-report-label"}>
                        Bộ lọc
                      </Typography>
                    </AccordionSummary>
                    {filterPlanTypeConfiguration && (
                      <ReportFilterLayout
                        data={filterPlanTypeConfiguration}
                        onChange={HandleOnChange}
                      />
                    )}
                    <AccordionActions>
                      <Button
                        onClick={handleSearchBasedOnFilter}
                        className="PlanHandle_0021 filter-report-search"
                        size="small"
                        startIcon={<MdSearch />}
                        variant="contained"
                        color="primary"
                      >
                        Tìm Kiếm
                      </Button>
                      {/* <Button
                      onClick={fn_reset}
                      className="PlanHandle_0022"
                      size="small"
                      startIcon={<MdUndo />}
                      variant="contained"
                      color="primary"
                    >
                      Làm mới
                    </Button> */}
                    </AccordionActions>
                  </Accordion>
                </div>
              </div>
              <div className="tablelistsms" style={{ maxWidth: "94%", width: "100%" }}>
                <MaterialTable
                  tableRef={tableRef}
                  columns={headerColumns}
                  data={dataColumns}
                  style={{
                    borderRadius: '20px',
                    boxShadow: 'rgb(100 100 111 / 20%) 0px 7px 29px 0px',
                    border: 'none'
                  }}
                  options={{
                    tableLayout: "auto",
                    draggable: false,
                    toolbar: true,
                    paging: true,
                    exportButton: {
                      csv: true,
                      pdf: false,
                    },
                    exportAllData: true,
                    filtering: true,
                    selection: true,
                    headerStyle: {
                      backgroundColor: "var(--itsm-bg-btn)",
                      color: "#FFF",
                      marginTop: "1%",
                      height: 100, maxHeight: 100, lineHeight: 1, textAlign: 'center', overflow: 'none',
                      paddingRight: 0, paddingBottom: 0, paddingTop: 0
                    },
                    actionsColumnIndex: -1,
                    fixedColumns: {
                      left: getStickyColumn,
                      right: 0,
                    },
                    pageSize: getPageSize,
                  }}
                  localization={{
                    pagination: {
                      labelDisplayedRows: "Từ {from} - đến {to} of {count}",
                    },
                    toolbar: {
                      exportCSVName: "Export danh sách chi tiết",
                      nRowsSelected: "Đã chọn {0} dòng",
                    },
                    header: {
                      actions: "",
                    },
                    body: {
                      emptyDataSourceMessage: "Không có dữ liệu",
                      deleteTooltip: "Xóa",
                      filterRow: {
                        filterTooltip: "Filter",
                      },
                      editRow: {
                        deleteText: "Bạn đã thực sự chắc chắn muốn xóa?",
                        cancelTooltip: "Hủy bỏ",
                        saveTooltip: "Đồng ý",
                      },
                    },
                  }}
                  title=""
                />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
